import React from 'react'

export default function FaceFeature({ scaleX, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} style={{ opacity: 0.2 }}>
      <path
        d="M1.89972 0.645874C2.22972 1.49587 2.17974 2.43591 1.91974 3.30591C1.77974 3.73591 1.56973 4.15599 1.28973 4.51599C1.01973 4.88599 0.639746 5.17598 0.239746 5.37598C0.649746 4.56598 0.959768 3.85593 1.19977 3.07593C1.44977 2.30593 1.62972 1.50587 1.89972 0.645874Z"
        fill={outline}
      />
      <path
        d="M3.7796 0.645874C4.0396 1.50587 4.2196 2.30593 4.4696 3.07593C4.7096 3.85593 5.01962 4.56598 5.42962 5.37598C5.02962 5.17598 4.64963 4.88599 4.37963 4.51599C4.09963 4.15599 3.88963 3.73591 3.74963 3.30591C3.48963 2.43591 3.4396 1.49587 3.7796 0.645874Z"
        fill={outline}
      />
    </g>
  )
}
